export const AUTH_REFRESH_PATH = '/authorization/refresh';
